import {
  ActivityServiceClient,
  ListActivityRequest,
  PageViewActivityRequest,
  ListActivityReportDetailsRequest,
} from '../proto/reportpb/activity_grpc_web_pb';
import { stringToProtoDate } from './ConvertService';
import authSvc from './AuthService';
import { auth } from '../lib/auth/Auth';
import { Pagination } from '../proto/utilspb/pagination_pb';

const service = new ActivityServiceClient(window.env.GRPC_ENDPOINT, {}, { ...auth });

const userId = authSvc.getCurrentUser()?.UserId;

const getListParameters = (param, paging) => {
  let req = new ListActivityRequest();

  const entryTypes = [];
  const sides = [];
  const statuses = [];

  if (param.entryType?.length > 0) {
    for (let i = 0; i < param.entryType?.length; i++) {
      entryTypes.push(param.entryType[i].entryType);
    }
  }

  if (param.side?.length > 0) {
    for (let i = 0; i < param.side?.length; i++) {
      sides.push(param.side[i].code);
    }
  }

  if (param.status?.length > 0) {
    for (let i = 0; i < param.status?.length; i++) {
      statuses.push(param.status[i].code);
    }
  }

  const entryType = "'" + entryTypes.join("','") + "'";
  const side = "'" + sides.join("','") + "'";
  const status = "'" + statuses.join("','") + "'";

  req.setFromDate(stringToProtoDate(param.fromDate));
  req.setToDate(stringToProtoDate(param.toDate));
  req.setCorrespondent(param.correspondent);
  req.setAccountNo(param.accountNo);
  req.setSubAccountNo(param.subAccountNo);
  req.setContraAccountNo(param.contraAccountNo);
  req.setMasterAccountNo(param.masterAccountNo);
  req.setBroker(param.broker);
  req.setType(param.type);
  req.setSymbol(param.symbol);
  req.setCusip(param.cusip);
  req.setStatus(status);
  req.setDateType(param.dateType);
  req.setEntryType(entryType);
  req.setAsoftrns(param.asOfTRNS);
  req.setQtyOnly(param.qtyOnly);
  req.setNetAmtOnly(param.netAmtOnly);
  req.setBranch(param.branch);
  req.setRep(param.rep);
  req.setSearchType(param.searchType);
  req.setCompressId(param.compressId);
  req.setSide(side);
  req.setTrnsId(param.trnsId);
  req.setAssetType(param.assetType);
  req.setAccountId(param.accountId);
  req.setDescription(param.description);
  req.setReferenceId(param.referenceId);
  req.setParticipantNo(param.participantNo);
  req.setBatchNo(param.batchNo);
  req.setTransactionSide(param.transactionSide);
  req.setCurrency(param.currency);
  req.setBreakdownOtherFees(param.breakdownOtherFees);
  req.setSubAccountType(param.subAccountType);
  req.setSubAccountNo(param.subAccountNo);
  req.setEffSettleDate(stringToProtoDate(param.effSettleDate));
  req.setCapacity(param.capacity);
  req.setEffTradeDate(stringToProtoDate(param.effTradeDate));
  req.setContraSubAccountNo(param.contraSubAccountNo);
  req.setContraAccountId(param.contraAccountId);
  req.setOriginalCusip(param.originalCusip);
  req.setDisableOriginalCusipMapping(param.disableOriginalCusipMapping);
  req.setIsReused(param.isReused);
  req.setDvpExternalId(param.dvpExternalId);
  req.setExternalId(param.externalId);
  req.setCreatedBy(param.createdBy);
  req.setMarginType(param.marginType);
  req.setMasterReference(param.masterReference);
  req.setIncludeTrnsIdsList(param.includeTrnsIds || []);

  if (paging) {
    let pg = new Pagination();
    pg.setPageNo(paging.pageNo);
    pg.setPageSize(paging.rowsPerPage);
    pg.setSortName(paging.sortName);
    pg.setSortDirection(paging.sortDirection);
    pg.setFilterNamesList(paging.filterNames);
    pg.setFilterValuesList(paging.filterValues);
    req.setPagination(pg);
  }

  return req;
};

export async function listActivities(param, paging) {
  return new Promise((resolve, reject) => {
    const req = getListParameters(param, paging);

    service.listActivities(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

// export async function listActivity(param) {
//   return new Promise((resolve, reject) => {
//     let req = new ListActivityRequest();
//     req.setFromDate(stringToProtoDate(param.fromDate));
//     req.setToDate(stringToProtoDate(param.toDate));
//     req.setBranch(param.branch);
//     req.setAccountNo(param.accountNo);
//     req.setMasterAccountNo(param.masterAccountNo);
//     req.setRep(param.rep);
//     req.setAccountName(param.accountName);
//     req.setSymbol(param.symbol);
//     req.setStatus(param.status);
//     req.setEntryType(param.entryType);
//     req.setSide(param.side);
//     req.setUsrId(userId);
//     req.setCompress(param.compress);
//     req.setCorrespondent(param.correspondent);
//     req.setDateType(param.dateType);

//     service.listActivity(req, {}, (error, response) => {
//       if (error) {
//         reject(error);
//       } else {
//         resolve(response.toObject());
//       }
//     });
//   });
// }

export async function listActivity(param, paging) {
  return new Promise((resolve, reject) => {
    const req = getListParameters(param, paging);

    service.listActivity(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function getActivitySummary(param, paging) {
  return new Promise((resolve, reject) => {
    const req = getListParameters(param, paging);

    service.getActivitySummary(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function pageViewActivity(searchData, paging, isDetails) {
  return new Promise((resolve, reject) => {
    let req = new PageViewActivityRequest();

    // const entryTypes = [];
    // const sides = [];
    // const statuses = [];

    // if (searchData.entryType?.length > 0) {
    //   for (let i = 0; i < searchData.entryType?.length; i++) {
    //     entryTypes.push(searchData.entryType[i].entryType);
    //   }
    // }

    // if (searchData.side?.length > 0) {
    //   for (let i = 0; i < searchData.side?.length; i++) {
    //     sides.push(searchData.side[i].code);
    //   }
    // }

    // if (searchData.status?.length > 0) {
    //   for (let i = 0; i < searchData.status?.length; i++) {
    //     statuses.push(searchData.status[i].code);
    //   }
    // }

    // const entryType = "'" + entryTypes.join("','") + "'";
    // const side = "'" + sides.join("','") + "'";
    // const status = "'" + statuses.join("','") + "'";

    req.setDateType(searchData.dateType);
    req.setFromDate(stringToProtoDate(searchData.fromDate));
    req.setToDate(stringToProtoDate(searchData.toDate));
    req.setCorrespondent(searchData.correspondent);
    req.setAccountNo(searchData.accountNo);
    req.setMasterAccountNo(searchData.masterAccountNo);
    req.setBranch(searchData.branch);
    req.setRep(searchData.rep);
    // req.setContraAccountNo(searchData.contraAccountNo);
    // req.setBroker(searchData.broker);
    // req.setType(searchData.type);
    req.setSymbol(searchData.symbol);
    // req.setCusip(searchData.cusip);
    req.setStatus(searchData.status);
    req.setEntryType(searchData.entryType);
    req.setSide(searchData.side);
    // req.setAssetType(searchData.assetType);
    // req.setTrnsId(searchData.trnsId);
    // req.setAsoftrns(searchData.asOfTRNS);
    req.setSearchType(searchData.searchType);
    // req.setDescription(searchData.description);
    // req.setParticipantNo(searchData.participantNo);
    // req.setBatchNo(searchData.batchNo);
    req.setAccountName(searchData.accountName);

    if (paging) {
      let pg = new Pagination();
      pg.setPageNo(paging.pageNo);
      pg.setPageSize(paging.rowsPerPage);
      pg.setSortName(paging.sortName);
      pg.setSortDirection(paging.sortDirection);
      pg.setFilterNamesList(paging.filterNames);
      pg.setFilterValuesList(paging.filterValues);
      req.setPagination(pg);
    }

    if (!isDetails) {
      service.pageViewActivity(req, {}, (error, response) => {
        if (error) {
          reject(error);
        } else {
          resolve(response.toObject());
        }
      });
    } else {
      service.pageViewActivityDetails(req, {}, (error, response) => {
        if (error) {
          reject(error);
        } else {
          resolve(response.toObject());
        }
      });
    }
  });
}

export async function listActivityReportDetails(id, archived) {
  return new Promise((resolve, reject) => {
    let req = new ListActivityReportDetailsRequest();
    req.setReportActivityId(id);
    req.setIsArchived(archived);

    service.listActivityReportDetails(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}
